import styled from 'styled-components';
import { flexBoxCenter, layerA } from 'shared/styles/commonStyles';

const HoverMessageBox = ({ message }) => {
  return (
    <Wrapper>
      <Message>{message}</Message>
    </Wrapper>
  );
};

export default HoverMessageBox;

const Wrapper = styled.div`
  width: fit-content;

  ${layerA};
  ${flexBoxCenter};
  padding: 0.2rem;
`;
const Message = styled.span`


  width: 150px;
  text-align: center;

  font-size: 8px;
  color: #ffffff;
  line-height: 90%;
`;
